import { AppError } from '@profile/src/redux/types';
export function formatErrorMessage(error, arg) {
  switch (error) {
    case AppError.UNNKOWN:
      return 'Something went wrong.\nPlease try again later.';

    case AppError.OUT_OF_LIMIT:
      return `You've reached maximum daily claim`;

    case AppError.NOT_ENOUGH_THC:
      return `You don't have enough coin. Try again`;

    case AppError.NOT_ENOUGH_THG:
      return `You don't have enough gem. Try again`;

    case AppError.MIN_DEPOSIT_EXCEEDED:
      return `Minimum deposit: ${arg === null || arg === void 0 ? void 0 : arg.minDeposit}`;

    default:
      return 'Something error happened try again later';
  }
}